import {forwardRef, useMemo} from 'react';
import {Checkbox} from '@guestapp/ui';
import type {Participant, ShortGuest} from '@guestapp/sdk';
import {sanitizeStringFromDashes} from 'utils/common';
import {List, GuestItemRow} from './styled';

interface Props {
  participants: Participant[];
  value: Participant[];
  onChange: (selected: Participant[]) => void;
  guests?: ShortGuest[];
}

export const SelectGuestList = forwardRef<HTMLDivElement, Props>(
  ({guests, participants, value, onChange}, ref) => {
    const handleToggle = (guest: Participant) => {
      const exists = value.some(g => g.id === guest.id);
      if (exists) {
        onChange(value.filter(g => g.id !== guest.id));
      } else {
        onChange([...value, guest]);
      }
    };

    const filteredParticipants = useMemo(() => {
      const guestParticipantIdsSet = new Set(
        guests?.map(guest => guest.participant_id) ?? [],
      );

      return participants.filter(
        participant =>
          !guestParticipantIdsSet.has(sanitizeStringFromDashes(participant.id)),
      );
    }, [guests, participants]);

    return (
      <List ref={ref}>
        {guests?.map(guest => (
          <GuestItemRow key={guest.id}>
            <Checkbox disabled value label={guest.full_name} className="check-box" />
          </GuestItemRow>
        ))}
        {filteredParticipants?.map(guest => (
          <GuestItemRow key={guest.id}>
            <Checkbox
              value={!!value.find(g => g.id === guest.id)}
              label={`${guest.name} ${guest.surname}`}
              className="check-box"
              onChange={() => handleToggle(guest)}
            />
          </GuestItemRow>
        ))}
      </List>
    );
  },
);
